module.exports = __webpack_public_path__ + "img/HeimwehScreenshot21.2b462237.png";